//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const maintenanceRoutes = [
  {
    path: i18n.global.t('routes.maintenance'),
    name: Routes.MAINTENANCE,
    component: () => import('@/components/maintenance/MaintenanceList.vue'),
    meta: {
      title: i18n.global.t('titles.maintenance'),
      active: 'maintenance',
      roles: [Permissions.ROLE_MAINTENANCE_INDEX],
    },
  },
];
